import { isHotel, isTourOffer, isVillaOffer } from 'lib/offer/offerTypes'
import { TASTE_OF_GOLD_MIN_PRICE } from '../constants/tasteOfGoldConstants'

/**
 * Checks whether an offer (or accommodation-service property) is eligible for the Taste of
 * Gold campaign. Eligible candidates are international Hotel, Villa, or Tour offers, or an
 * accommodation-service property (always a hotel-shape) with a minimum price in AUD.
 */
function isTasteOfGoldEligibleOffer(
  offerOrProperty: App.AnyOffer | App.Property.Property,
  currency: string,
  isInternational: boolean,
  price: number,
): boolean {
  const isEligibleType = 'type' in offerOrProperty
    ? (isHotel(offerOrProperty) || isVillaOffer(offerOrProperty) || isTourOffer(offerOrProperty))
    : true
  return isEligibleType &&
    currency === 'AUD' &&
    isInternational &&
    price >= TASTE_OF_GOLD_MIN_PRICE
}

export default isTasteOfGoldEligibleOffer
